export default __webpack_public_path__ + "static/media/lock.cbbd9d01.svg";